<template lang="pug">
  ctr-goal-display(v-if="resolvedFormat === 'ctr'", :value="value")
  impression-ratio-display(v-else, :value="value")
</template>

<script>
import ImpressionRatioDisplay from "./ImpressionRatioDisplay.vue";
import { getImpratioFormat } from "@/utils/impratio-format";

export default {
  name: "ImpratioDisplay",
  components: {
    ImpressionRatioDisplay,
  },
  props: {
    value: {
      type: [String, Number],
    },
    format: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedFormat() {
      if (this.format) return this.format;
      const user = this.$store && this.$store.state ? this.$store.state.user : null;
      return getImpratioFormat(user);
    },
  },
};
</script>

